import { render, staticRenderFns } from "./StatusLegend.vue?vue&type=template&id=773c1e33"
import script from "./StatusLegend.vue?vue&type=script&lang=js"
export * from "./StatusLegend.vue?vue&type=script&lang=js"
import style0 from "./StatusLegend.vue?vue&type=style&index=0&id=773c1e33&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports